(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9723],{

/***/ 85250:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-ideas/bathroom-designs/blue-bathroom",
      function () {
        return __webpack_require__(81170);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52681);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31955);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63372);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83346);
/* harmony import */ var _src_components_design_pages_imageList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36774);












const tileData = [
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/300x600 SDH SACRED LOTUS HL 1, SDG SACRED BLUE DK, SDG SACRED BLUE LT, SDM SACRED BLUE FL.webp",
        alt: "Blue bathroom design with a sleek bathtub, wall mirror and large window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/300x600 SHM CEMENTUM CUBE 3D HL, SBM CEMENTUM BLUE DK, SBM CEMENTUM BLUE LT, SFM CEMENTUM BLUE DK.webp",
        alt: "Modern blue bathroom design with double mirror, double sink setup"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/GFT SPH ECHO Hibiscus HL, GFT SPB Ocean Blue DK & GFT SPB Ocean LT__Bathroom Ambiance_Ceramic Sparkle Wall Tiles_300x450 MM.webp",
        alt: "Stylish blue bathroom design featuring ocean blue tiles, a sink and a large window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/GFT SPH Geometric Aqua HL_Bathroom Ambiance_Ceramic Sparkle Wall Tiles_300x450 MM.webp",
        alt: "Elegant blue bathroom design featuring ceramic sparkle tiles, double sink and mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/NEVADA BIANCO OE 2122, ODH TRAPEZOID BLUE HL_300x600 mm.webp",
        alt: "Blue bathroom design with countertop sink and round mirror above"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/ODG Sea Water, ODG Sea Sand Beige, ODG Sea Sky, ODH Hectors Dolphin HL 1, 2 & ODH Sea Shells HL_Bathroom_30x45 CM.webp",
        alt: "Stylish blue bathroom design with sink, mirror, and ocean-inspired tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/ODG Statuario Bianco, ODH Statuario Wave Bianco HL_Bathroom Ambiance_Ceramic Wall Tiles_300x450 MM.webp",
        alt: "Blue bathroom design with bathtub, window and Statuario Bianco Wave ceramic wall tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/ODG True Blue Mosaic Dark, ODG Thunder Blue & ODM Thunder Blue FL_Bathroom Ambiance_Ceramic Wall Tiles_300x450 MM.webp",
        alt: "Contemporary blue bathroom with large window and sink with cabinets"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/ODH DOLPHIN TOP LEFT HL, ODH DOLPHIN TOP RIGHT HL, ODH DOLPHIN BOTTOM LEFT HL, ODH DOLPHIN BOTTOM RIGHT HL, ODG DOLPHIN DK & ODG DOLPHIN LT_Bathroom Ambiance_Ceramic Wall Tiles_300x450 MM.webp",
        alt: "Sophisticated blue bathroom design with a white bathtub, window and mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/SHG Aqua Blue Honeycomb HL, SBG Aqua Blue Stucco, SBG White Stucco & SFM Aqua Blue Stucco_300x450 mm.webp",
        alt: "Trendy blue bathroom design featuring a contemporary sink, mirror and shower area"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/SHG Azul Streak Dusk Strip HL, SBG Azul DK Streak Dusk, SBG Azul LT Streak Dusk & SFM Azul DK Streak Dusk_300x450 mm.webp",
        alt: "Charming blue bathroom design with a functional sink with cabinet and mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/SHG Blue Popsicle Floral HL, SBG Gold Blue Popsicle, SBG Gold White Popsicle & SFM Gold Blue Popsicle_300x450 mm.webp",
        alt: "Blue bathroom design showcasing popsicle floral tiles, sink and bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/SHG Blue Portuguese Mosaic HL, SBG Blue DK Mosaic, SBG Blue LT Mosaic & SFM Blue DK Mosaic_300x450 mm.webp",
        alt: "Modern blue bathroom design showcasing a sink, round mirror and bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/SHG BRICK MARMI MARBLE HL, SBG MARMI MARBLE BLUE DK, SBG MARMI MARBLE BLUE LT & SFM MARMI MARBLE BLUE DK _300x600mm.webp",
        alt: "Trendy blue bathroom design with bathtub, sink and western toilet for a sleek look"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/SHG DAHLIA FLOWER BLUE HL,SHG DIAMOND CHAIN BLUE HL, SDG ARADOR BLUE DK, SDG ARADOR BLUE LT & SDM ARADOR BLUE DK FL _300x450mm.webp",
        alt: "Elegant blue bathroom design with bathtub, sink and western toilet for a sleek look"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/SHG Fabric Arrow Petal HL, SBG Grey Fabric, SBG Silver Fabric & SFM Grey Fabric_300x450 mm.webp",
        alt: "Blue bathroom featuring a double sink with mirror, large window, and trendy fabric textures"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/Elegant small blue bathroom with mosaic tile.webp",
        alt: "Elegant small blue bathroom with textured and mosaic tile accents"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/Blue bathroom with floating wooden cabinet.webp",
        alt: "Blue bathroom design showcases a floating wooden cabinet"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/Modern blue bathroom pair with soft blue tones.webp",
        alt: "Modern Blue bathroom ideas pair with bathtub area"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/Stylish wooden vanity small blue bathroom.webp",
        alt: "Stylish wooden vanity and copper sink setup for small blue bathroom ideas"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/Blue bathroom design with brick strip tiles.webp",
        alt: "Blue bathroom design featuring brick strip tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/small blue bathroom with luxury wooden cabinet.webp",
        alt: "Creative small blue bathroom with white luxury bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Blue color - 16/3D-effect blue bathroom design.webp",
        alt: "3D-effect blue bathroom design with stylish accents"
    }
];
const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
        {
            breakpoint: 991,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 641,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 1
            }
        }
    ]
};
const faqs = [
    {
        question: "What aspects should I consider while planning a bathroom?",
        answer: "Consider the available area, the desired overall style, ventilation, lighting, storage needs, and ventilation. Do not forget to infuse your flair into the design as well but give priority to functionality also."
    },
    {
        question: "Can a small bathroom be made to appear bigger?",
        answer: "Yes, you can make a small bathroom look bigger with a few smart design choices. Using light colours like white or soft pastels can create an open feel. Large mirrors can reflect light and give an illusion of space. Opt for large tiles with fewer grout lines and install proper lighting. Keeping the d\xe9cor minimal and using wall-mounted fixtures also helps to make the room feel more spacious."
    },
    {
        question: "What are some of the recent trends in bathroom decor?",
        answer: "Popular trends in bathroom d\xe9cor focus on creating a spa-inspired ambiance with neutral tones, natural elements, and soft lighting. Patterned or textured wall tiles paired with stylish flooring and well-placed mirrors are commonly seen. Additionally, glossy marble tiles for walls combined with matte finish tiles for floors and metallic d\xe9cor elements, have become popular choices, offering a mix of elegance and contemporary style."
    },
    {
        question: "How to select the best flooring for my bathroom?",
        answer: "Select flooring materials that offer resistance against moisture, such as vitrified tiles or ceramic tiles. Orientbell Tiles has a collection of anti-skid tiles that will be ideal for a bathroom. Along with the practical side, consider your design choices, maintenance requirements, and budget."
    },
    {
        question: "Which type of lighting works the best in a bathroom?",
        answer: "You can go ahead with the combination of ambient, and accent lighting to make a bathroom seem cosy and well-lit. "
    },
    {
        question: "Is it better to work with an expert designer or can I design my own bathroom?",
        answer: "Hiring a designing expert brings experience, saves time, and brings a consistent style. However, if you are on a tight budget, creating your bathroom design is achievable with careful planning and study."
    }
];
const text = " Blue bathroom designs are known to offer a refreshing look while building a calming atmosphere that makes them perfect for any bathroom remodel. Whether you are working with space limitations or a larger area, blue can have a significant impact on the overall design. \nWhen using lighter shades of blue, you can create a serene environment, whereas deep navy tones add a sophisticated and rich look. Because of its calming nature, the blue bathroom design can provide the ultimate comfort. When combined with different materials and features, such as blue tiles, accents, and fixtures, your bathroom gets a makeover while maintaining an airy and spacious feel. Explore various blue bathroom ideas to bring a unique touch to your bathroom.\n";
function BlueBathroom() {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [isExpertTalkClicked, setIsExpertTalkClicked] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [relatedBlogData, setRelatedBlogData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [isReadMore, setIsReadMore] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [showAll, setShowAll] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        getRelatedBlogs();
    }, []);
    const toggleReadMore = ()=>{
        setIsReadMore(!isReadMore);
    };
    var requestOptions = {
        method: "GET"
    };
    const getRelatedBlogs = async ()=>{
        // try{
        fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_7__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/blog/wp-json/post/v2/category/term=bathroom-designs"), requestOptions).then((response)=>response.text()).then((result)=>{
            setRelatedBlogData(JSON.parse(result));
        }).catch((error)=>console.log("error", error));
    };
    const handleToggle = (index)=>{
        setActiveIndex(activeIndex === index ? null : index);
    };
    const maxChars = 300;
    const previewText = text.substring(0, maxChars);
    const remainingText = text.substring(maxChars);
    const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Blue Bathroom Tiles Design | Blue Bathroom Ideas | Orientbell Tile"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "Blue Bathroom Tiles Design | Blue Bathroom Ideas | Orientbell Tile"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Discover blue bathroom tile designs & ideas at Orientbell. Explore classic to modern styles using elegant blue tiles to create a serene, stylish space."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "designpage-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                    href: "https://www.orientbell.com",
                                    children: "Home"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                    href: "https://www.orientbell.com/design-ideas/",
                                    children: "Design Ideas"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                    href: "https://www.orientbell.com/design-ideas/bathroom-designs",
                                    children: "Bathroom Designs"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                    href: "https://www.orientbell.com/design-ideas/bathroom-designs/blue-bathroom",
                                    children: "Blue Bathroom"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "designpage-heading-bx padding-spacing",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                    children: [
                                        "Showing ",
                                        tileData.length,
                                        " results for "
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: "Blue Bathroom Design"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "description-text",
                                    children: [
                                        previewText,
                                        !isReadMore && text.length > maxChars && "...",
                                        isReadMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: remainingText
                                        }),
                                        text.length > maxChars && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: toggleReadMore,
                                            children: isReadMore ? "Read Less" : "Read More"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "obl-master-design-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Blue Bathroom Gallery"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "designpage-category-row inner-design-gallery",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_design_pages_imageList__WEBPACK_IMPORTED_MODULE_8__/* .ImageList */ .Y, {
                                        tileData: tileData
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bottom-content",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "Modern Blue Bathroom Ideas"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "The refreshing feeling one would get from a blue bathroom\n                  makes it perfect for a modern vibe. Here's how to make your\n                  bathroom seem perfect with modern blue design ideas."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Clean and Fresh:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Blue shades can provide calmness and a spacious feeling in the bathroom. If it is a small bathroom, light blues or pastels will do wonders there giving it a bright feel to it."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Mix Colours and Materials:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Add blue tiles with contrasting colours like white or grey to create a visual balance. For added texture, consider using materials like glass, stone, or metallic accents. Mixing finishes, such as matte and glossy, not only enhances the depth of the design but also brings warmth to the cool tones of blue."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Minimalist Design:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "The calming effect of blue goes well with the clean lines and simple fixtures in a minimalist approach. This would be ideal for a clutter-free, modern bathroom."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Accent Features: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Add blue mosaic tiles or bold navy backsplash to create great visual interest. These elements add a lot of drama and do not overwhelm the room."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Statement Fixtures: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Upgrade your bathroom with modern fixtures. Consider faucets, stylish mirrors, and trendy shower heads in metallic or matte finishes to complement the blue tones and enhance the overall design."
                                                                }),
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: " How Do I Determine My Modern Blue Bathroom Layout?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "When planning your modern blue bathroom layout, it’s essential to focus on both functionality and style. Here are some helpful tips for designing the perfect space:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Consider Your Space:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "How much space do you have in your bathing area? The size of your bathroom will help you pick the ideal layout. If the area is small, creative ideas such as putting floating shelves for storage and using a large mirror or compact fixtures like wall-mounted sinks would be perfect for making maximum use of the space in your bathroom."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Take Care of Safety and Comfort:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Provide space between the functional elements so you can move in easily. The layout should present easy movement around the general features and a good access for them."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Think About Your Needs:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Do you know what features you need in your bathroom? You may have a shower but not enough space to have a bathtub or vice versa. You may also have a sink area large enough but have limited storage space or maybe there is ample floor space, and yet no additional space for towel racks or cabinets."
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Tailoring your layout to maximise functionality can make a\n                      big difference. Make sure you consider your and your\n                      family members' needs when deciding where to place every\n                      element in your blue bathroom to ensure functionality and\n                      comfort for everyone."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Maximise Storage: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Make sure there is space for all your necessary storage. Install floating shelves or cabinets that can assist you in the organisation of toiletries and towels without cluttering your bathroom. Also, make sure your storage cabinets are easy to reach and can be easily organised, perfectly matching your blue bathroom design."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "What Materials Should I Use in My Blue Bathroom Design?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        "To design an elegant blue bathroom, you must pick the right tiles and elements for both elegance and usability. Here is a list of materials that you should consider.",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Choose the Right Wall and Floor Tiles: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Combine blue tiles in varying shades and designs to create different looks. No matter which design you are aiming for, blue tile in a glossy finish for the walls offers an elegant feel. Consider picking blue or contemporary colour floor tiles with anti-skid surfaces. They can enhance safety across the bathroom while offering comfort underfoot. Also, you can opt for subway tiles for backsplash. Choosing tiles in large sizes will have fewer grout lines and make the maintenance easier."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Combine Different Finishes: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Choose glossy tiles for the walls, especially for smaller bathrooms to create a brighter look and more open feel. Install cabinets with unpolished finishes to balance the look. Also, use matte-finish or anti-skid floor tiles for flooring to improve safety."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Granite Tile Countertops:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Opt for granite tiles for your bathroom’s countertop. Their durable and non-porous nature can be a perfect addition to the bathroom. You can choose classic black granite for a sleek, modern look or go for brown tones to add warmth and richness. If you prefer a lighter touch, cream-coloured granite tiles can create a soft, inviting ambience."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Storage Cabinets: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "For a blue bathroom, you can pick a cabinet with a sleek, matte finish. For example, wooden cabinets can add warmth and texture, while a floating vanity creates a more open feel in the bathroom. Additionally, closed cabinets offer extra storage to keep things organised."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Faucets and Hardware: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Choose faucets and hardware that complement the overall theme of your bathroom. Antique bronze, brushed stainless steel or gold finishes work beautifully in modern bathroom designs. Pair them with matching towel racks, drawer pulls, and showerheads to create a cohesive and refined look."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "How Do I Decorate My Modern Blue Bathroom?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "It's all about creating a most soothing and stylish design in\n                  a modern blue bathroom, enhancing the overall feel and comfort\n                  of the space. Here are some decorating ideas to take your\n                  bathroom decor to a whole new level:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Add Decorative Accessories:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Use accessories like soap dishes, towels, or shower curtains in white, silver, or navy. These colours go very well with the blue tones and give your colour scheme a fun touch."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Highlight with Mirrors:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Use metallic or wooden framed bathroom mirrors to complement the coolness of blue. A big mirror can lighten up the wall area and make your bathroom look more spacious."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Play with Patterns: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Add textural or patterned elements, such as wave designs or striped rugs. Such patterns are great at enhancing the soothing feel while keeping up to date with modern trends."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Choose Complementary Fixtures: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    children: [
                                                                        "Go for streamlined faucets, showerheads, and towel bars in a finish such as chrome or matte black. These finishes appear to match well with blue and create a pretty polished",
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "https://www.orientbell.com/design-ideas/bathroom-designs/",
                                                                            children: "bathroom design"
                                                                        }),
                                                                        "."
                                                                    ]
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Maximise Wall Space:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Make use of floating shelves or a wall-mounted cabinet in neutral shades to store the essentials, yet keep the decor uncluttered. This is highly helpful for smaller bathrooms."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Install New Fixtures: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Upgrade your bathroom fixtures like shower heads, faucets, and towel bars. This small change can upgrade the overall bathroom’s look."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Include Natural Touches:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Add some plants or wood accents to balance out the coldness of the tones. Any space can become more lovely when a small potted plant or a bamboo accent piece is included."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tile-related-blog",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "title",
                                            children: "Related Blogs"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "designpage-relatedpost-row",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                ...settings,
                                                children: relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.map((obj, index)=>{
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "related-blog-col",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "blog-figure",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: obj.permalink,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: obj.image,
                                                                        loading: "lazy",
                                                                        alt: "Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "blog-text",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingDate",
                                                                        children: obj.date
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingHead",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: obj.permalink,
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: obj.title
                                                                                }
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "listingText",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        dangerouslySetInnerHTML: {
                                                                                            __html: obj.content.slice(0, -11)
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "listingButton",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                    href: obj.permalink,
                                                                                    children: "Read More"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (BlueBathroom);


/***/ }),

/***/ 36774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ImageList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31955);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63372);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4492);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35005);





const ImageList = (param)=>{
    let { tileData  } = param;
    const [isExpertTalkClicked, setIsExpertTalkClicked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showAllTiles, setShowAllTiles] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [displayedTileData, setDisplayedTileData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(tileData.slice(0, 6));
    const [touch, setTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "",
        number: "",
        pincode: js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("pincode"),
        error: "",
        loading: false
    });
    const submitGetInTouch = async ()=>{
        const namee = touch.name;
        const no = touch.number;
        const pin = touch.pincode;
        if (!namee || !no || !pin) {
            setTouch({
                ...touch,
                error: "All fields are required"
            });
        } else if (String(pin).length != 6) {
            setTouch({
                ...touch,
                error: "Invalid Pincode"
            });
        } else {
            setTouch({
                ...touch,
                error: "",
                loading: true
            });
            let response = await (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_3__/* .getIntouch */ .JJ)({
                name: namee,
                phone: no,
                pincode: pin
            });
            if (response === null || response === void 0 ? void 0 : response.message) {
                localStorage.setItem("leadfilled", true);
                swal(response === null || response === void 0 ? void 0 : response.message);
                setTouch({
                    ...touch,
                    error: "",
                    loading: false
                });
            } else {
                swal(response.data.get_in_touch.msg);
                // setGetInTouch(false)
                setTouch({
                    name: "",
                    number: "",
                    error: "",
                    loading: false
                });
                setIsExpertTalkClicked(false);
            }
        }
    };
    const handleViewMore = ()=>{
        if (!showAllTiles) setDisplayedTileData((prev)=>[
                ...prev,
                ...tileData.slice(prev.length, prev.length + 6)
            ]);
        if (showAllTiles) setDisplayedTileData(tileData.slice(0, 6));
        if (displayedTileData.length + 6 >= tileData.length) setShowAllTiles(!showAllTiles);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "designpage-category-row inner-design-gallery",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "designpage-category-row inner-design-gallery",
                children: displayedTileData.map((tile, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "designpage-category-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "designpage-figure",
                                children: tile.src ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    ...tile,
                                    loading: "lazy"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: tile.image,
                                    alt: tile.alt,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "designpage-text",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "talk-expert-btn talk-to-expert-design-page",
                                    onClick: ()=>setIsExpertTalkClicked(true),
                                    children: "Talk to Expert"
                                })
                            })
                        ]
                    }, index))
            }),
            tileData.length > 6 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tru_btn_new design-page",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "btn btn-primary",
                    onClick: handleViewMore,
                    children: showAllTiles ? "View Less" : "View More"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                show: isExpertTalkClicked,
                className: "pincode-popup-bx expert_assistance_modal ask-question-popup",
                onHide: ()=>{
                    // setTimePopup(false)
                    // setGetInTouch(false)
                    setIsExpertTalkClicked(false);
                // localStorage.setItem('leadSkiped',true)
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Dialog */ .Z.Dialog, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Header */ .Z.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Title */ .Z.Title, {
                                children: "Get in touch with our tile expert"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ask-question-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "expert-fig-bx",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/new-tareek.jpg"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Body */ .Z.Body, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: "Ask Tile Expert"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Let Experts Help You In Buying Process"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            onSubmit: (e)=>{
                                                e.preventDefault();
                                                submitGetInTouch();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicEmail",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Label */ .Z.Label, {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Control */ .Z.Control, {
                                                            type: "text",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    name: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Label */ .Z.Label, {
                                                            children: "Mobile"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    number: "".concat(touch.countryCode || "").concat(e.target.value)
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Label */ .Z.Label, {
                                                            children: "Pincode"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            value: touch.pincode,
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    pincode: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                touch.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "error text-danger",
                                                    children: touch.error
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    variant: "primary",
                                                    type: "submit",
                                                    disabled: touch.loading,
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    children: touch.loading ? "Submitting" : "Submit"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 52681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15094);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const Breadcrumb = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  listProps = {},
  children,
  label = 'breadcrumb',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ol", {
      ...listProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Breadcrumb, {
  Item: _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
}));

/***/ }),

/***/ 15094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13551);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const BreadcrumbItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  active = false,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  linkProps = {},
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LinkComponent, {
      ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7312,7767,5518,4585,7615,6212,2770,3372,9774,2888,179], function() { return __webpack_exec__(85250); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);